import { render } from "./Bill.vue?vue&type=template&id=7c2e0e17&scoped=true&ts=true"
import script from "./Bill.vue?vue&type=script&lang=ts"
export * from "./Bill.vue?vue&type=script&lang=ts"

import "./Bill.vue?vue&type=style&index=0&id=7c2e0e17&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2e0e17"]])

export default __exports__